import FormInfo from './FormInfo';

export default FormInfo;
